import React from "react";
import ProductSelect from "./product/ProductSelect";
import ProductStackCards from "./product/ProductStackCards";
import ProductCards from "./product/ProductCards";
import { Product } from "../shared/types";

interface ProductDisplayProps {
  productDisplayType: string;
  products: Product[];
  selectedProductIndex: number | null;
  currency: string;
  theme: string;
  onProductChange: (index: number) => void;
}

const ProductDisplay: React.FC<ProductDisplayProps> = ({
  productDisplayType,
  products,
  selectedProductIndex,
  currency,
  theme,
  onProductChange,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getCurrencySymbol = (currency: string): string => {
    switch (currency) {
      case "eur":
        return "€";
      default:
        return "$";
    }
  };
  return (
    <>
      <legend className="text-sm font-semibold leading-6 text-gray-90 flex justify-between px-4">
        <span>{theme === "ttr" ? "Your Upgrade" : "Select Product"}</span>

        <span>Price</span>
      </legend>
      {productDisplayType === "stacked-cards" ? (
        <ProductStackCards
          simpleProducts={products}
          selectedProductIndex={selectedProductIndex}
          onProductChange={onProductChange}
          currency={currency}
        />
      ) : productDisplayType === "cards" ? (
        <ProductCards
          simpleProducts={products}
          selectedProductIndex={selectedProductIndex}
          onProductChange={onProductChange}
          currency={currency}
        />
      ) : (
        <ProductSelect
          simpleProducts={products}
          selectedProductIndex={selectedProductIndex}
          onProductChange={onProductChange}
          currency={currency}
        />
      )}
    </>
  );
};

export default ProductDisplay;
